/**
 * The "Pre-book" marker (spec 16, design 18).
 *
 * Its own component rather than an inline `MetaPill` because it appears on four
 * screens — the order book, order detail, the quote book and quote detail — and
 * the one thing that must not drift is the tone. Neutral is deliberate: kind is
 * **taxonomy**, not state, and every one of those screens already carries a
 * coloured status pill. A second coloured dot beside it would read as a second
 * status (brand-spec §2.3: colour alone never carries meaning).
 *
 * Renders nothing for an at-once row, so callers can drop it in unconditionally
 * and at-once output stays byte-identical (spec 16 AC5).
 */
import { MetaPill } from "@flint/ui";

export function PrebookPill({ kind }: { kind: "at_once" | "prebook" }) {
  if (kind !== "prebook") return null;
  return (
    <MetaPill tone="neutral" className="shrink-0">
      Pre-book
    </MetaPill>
  );
}
